/* global axios */
import ApiClient from './ApiClient';

class InboxTeams extends ApiClient {
  constructor() {
    super('inbox_teams', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}`);
  }

  update({ inboxId, teamIds }) {
    return axios.post(`${this.url}/${inboxId}`, { team_ids: teamIds });
  }
}

export default new InboxTeams();
